// extracted by mini-css-extract-plugin
export default {"img":"ingredient-details_img__xgOka","header":"ingredient-details_header__ScQ6W","wrapper":"ingredient-details_wrapper__uW729","desc":"ingredient-details_desc__copUz"};